import SuggestionsFilter from './SuggestionsFilter'
import ListFilter from './ListFilter'

import { formatTopicsAndKeywordsCount } from '../../../utils'

import s from './AppliedFilters.module.css'

type Props = {
  isSuggestionsFilter?: boolean
}

export const AppliedFilters = ({ isSuggestionsFilter }: Props) => {
  return (
    <div className={s.wrapper}>
      {isSuggestionsFilter ? (
        <SuggestionsFilter
          formatTopicsAndKeywordsCount={formatTopicsAndKeywordsCount}
        />
      ) : (
        <ListFilter
          formatTopicsAndKeywordsCount={formatTopicsAndKeywordsCount}
        />
      )}
    </div>
  )
}
